import { Hero } from "@/components/Hero";
import { WhySection } from "@/components/WhySection";
import { ProcessSection } from "@/components/ProcessSection";
import { ServiceModelsSection } from "@/components/ServiceModelsSection";
import { IntegrationsChannelsSection } from "@/components/IntegrationsChannelsSection";
import { SecuritySection } from "@/components/SecuritySection";
import { UseCasesSection } from "@/components/UseCasesSection";
import { MigrationSection } from "@/components/MigrationSection";
import { FAQSection } from "@/components/FAQSection";
import { CTASection } from "@/components/CTASection";
import { VideosSection } from "@/components/VideosSection";
import { SiteLayout } from "@/layouts/site-layout";
import { SEO } from "@/components/SEO";

const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Clawbiz — Personal AI Assistant",
    "description": "Clawbiz — The AI that actually does things. Your personal assistant on any platform.",
    "url": "https://clawbiz.ai",
    "applicationCategory": "AI Assistant",
    "operatingSystem": "Cross-platform",
  };

  return (
    <SiteLayout>
      <SEO
        title="Clawbiz — Personal AI Assistant"
        description="Clawbiz — The AI that actually does things. Your personal assistant on any platform."
        keywords="Clawbiz, AI assistant, personal AI, self-hosted AI, WhatsApp AI, Telegram bot, Discord bot"
        canonicalUrl="https://clawbiz.ai/"
        structuredData={structuredData}
      />
      <Hero />
      <WhySection />
      <ServiceModelsSection />
      <ProcessSection />
      <IntegrationsChannelsSection />
      <SecuritySection />
      <UseCasesSection />
      <MigrationSection />
      <VideosSection />
      <FAQSection />
      <CTASection />
    </SiteLayout>
  );
};

export default Index;
